export default "__VITE_ASSET__bbb93459__"